import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, onValue, update } from "firebase/database";
import { useNavigate } from "react-router-dom";
import "../css/Homepage.css"; // 引入你的 CSS 文件

const TeacherDashboard = () => {
  const [waitingQuestions, setWaitingQuestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const qRef = ref(db, "waitingQuestions");
    const unsubscribe = onValue(qRef, (snapshot) => {
      const data = snapshot.val() || {};
      const list = Object.entries(data)
        .filter(([_, v]) => !v.matched)
        .map(([id, value]) => ({ id, ...value }));
      setWaitingQuestions(list);
    });

    return () => unsubscribe();
  }, []);

  const handleMatch = async (question) => {
    await update(ref(db, `waitingQuestions/${question.id}`), {
      matched: true,
      teacherId: "teacher123",
    });

    navigate(`/teacher-chat?id=${question.id}`);
  };

  return (
    <div className="homepage">
      <div className="features">
        <div className="features-header">
          <h2>Waiting Student Questions</h2>
          <p>Click 'Match' to start helping students in real-time chat.</p>
        </div>

        <div className="features-grid">
          {waitingQuestions.map((q) => (
            <div key={q.id} className="feature-card">
              <div className="feature-icon">📘</div>
              <h3>{q.subcategory}</h3>
              <p>{q.description}</p>
              <button className="cta-primary" onClick={() => handleMatch(q)}>
                Match
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeacherDashboard;